import { IInputProps } from '../atoms/InputBase/InputBase';

interface IGetSubtextArgs {
    validationError: boolean;
    errorMessage: string;
    error: IInputProps['error'];
    errorText: IInputProps['errorText'];
    advanced: IInputProps['advanced'];
    helperText: IInputProps['helperText'];
    description: IInputProps['description'];
}
interface IGetRequiredMessageArgs {
    label: IInputProps['label'];
}
/**
 * Determines what is rendered underneath the input field.
 */
export function getSubtext({
    validationError,
    errorMessage,
    error,
    errorText,
    advanced,
    helperText,
    description,
}: IGetSubtextArgs) {
    if (validationError) {
        return errorMessage;
    }
    if (error) {
        return errorText ?? '';
    }
    if (advanced) {
        return helperText ?? '';
    }
    return description ?? '';
}

/**
 * When the inputs are refactored. PLEASE consider removing this function all together
 * so that the error messages can belong to the component
 */
/**
 * Determines the required error message based on the label.
 */
export function getRequiredMessage({ label }: IGetRequiredMessageArgs) {
    if (typeof label === 'string') {
        const lowerCaseLabel = label.toLowerCase();
        if (lowerCaseLabel.includes('name')) {
            return `Please enter your ${(
                label.charAt(0).toUpperCase() +
                label.slice(1).toLowerCase().replace('name', '')
            ).trim()} Name`;
        }

        const verb =
            lowerCaseLabel.includes('account') ||
                lowerCaseLabel.includes('routing')
                ? 'enter'
                : 'provide';

        const noun = resolveNoun(lowerCaseLabel);

        return `Please ${verb}${lowerCaseLabel.includes('income') ? '' : ' a'
            } valid ${noun}`;
    }

    return `Please provide a valid ${label}`;
}

const resolveNoun = (lowerCaseLabel: string) => {
    if (lowerCaseLabel.includes('zip')) {
        return 'ZIP Code';
    }
    if (lowerCaseLabel.includes('social')) {
        return 'Social Security number';
    }
    if (lowerCaseLabel.includes('income')) {
        return 'Your Total Monthly Income';
    }
    if (lowerCaseLabel.includes('phone')) {
        return 'phone number';
    }
    if (lowerCaseLabel.includes('email')) {
        return 'email address: email@domain.com';
    }
    return lowerCaseLabel;
};